// Expand all / Collapse all for a page's collapsible cards (S163): the page holds the last
// command and provides it; every CollapsibleCard under it follows each new command (and remembers
// it, as a click on its own header would). Without a provider a card only answers its header.
import { createContext, useContext } from "react";

export interface CardGroupCommand {
  open: boolean;
  /** Counts the commands, so the same command given twice still applies. */
  seq: number;
}

export const CardGroupContext = createContext<CardGroupCommand | undefined>(undefined);

export function useCardGroupCommand(): CardGroupCommand | undefined {
  return useContext(CardGroupContext);
}
